import { SelectionStatus } from "../../data";
export const isNonRunner = (selection) => (selection === null || selection === void 0 ? void 0 : selection.status) === SelectionStatus.NonRunner ? 1 : 0;
//# sourceMappingURL=isNonRunner.js.map